import {Component, Input, OnInit} from '@angular/core';
import {CommonModule} from '@angular/common';
import {Aangifte, BokkzIbDataService} from "@snelstart-ventures/fiscaal/domain-logic";

@Component({
    selector: 'snelstart-venture-fiscaal-feature-tekst-persoonlijk-aangever',
    standalone: true,
    imports: [CommonModule],
    templateUrl: './tekst-persoonlijk-aangever.component.html',
    styleUrl: './tekst-persoonlijk-aangever.component.scss',
})
export class TekstPersoonlijkAangeverComponent implements OnInit {

    @Input() public id!: string;
    public ibAangifte = {} as Aangifte;
    public focusedElementId: string | null = null;
    public year = 2024;
    public actualYear: number = new Date().getFullYear();

    public bedragTeBetalen = 0;
    public bedragTeruggave = 0;
    public bedragVermogen = 0;
    public bedragVermogenMetPartner = 0;

    constructor(
        public dataService: BokkzIbDataService) {
    }

    ngOnInit(): void {
        this.dataService.incomeTaxEntity.subscribe((value) => {
            if (value.year !== undefined) {
                this.year = value.year;
            }
            if (this.year === 2023) {
                this.bedragTeBetalen = 52;
                this.bedragTeruggave = 17;
                this.bedragVermogen = 33748;
                this.bedragVermogenMetPartner = 67496;
            }
            if (this.year === 2024) {
                this.bedragTeBetalen = 57;
                this.bedragTeruggave = 19;
                this.bedragVermogen = 36.952;
                this.bedragVermogenMetPartner = 73.904;
            }
            if (this.year === 2025) {
                this.bedragTeBetalen = 58;
                this.bedragTeruggave = 19;
                this.bedragVermogen = 37.395;
                this.bedragVermogenMetPartner = 74.790;
            }
        })
    }

}
